module.exports = __webpack_public_path__ + "img/logo_course.8016e34a.png";